import type { SubscriptionPlanPrice } from 'v2/interfaces/subscriptions';

import type ICoProducer from './ICoProducer';

export enum EPartnerCode {
  BLINKET = 28,
  SERVICE = 29,
  ALUMY = 36,
}

interface Plan {
  plan_id: number;
  membership_comission_value: number;
  recurring_comission_value: number;
  comission_on_first_invoice: boolean;
}

interface IProduct {
  sku?: string;
  id: number;
  title: string;
  description: string;
  active: number;
  image_id: number;
  image: string;
  expiration_date: string;
  has_expiration_date: boolean;
  interest_free_installment: boolean;
  sales_recovery: boolean;
  allows_boleto: boolean;
  allows_pix: boolean;
  allows_paypal: boolean;
  allows_card: boolean;
  allows_multiple_cards: boolean;
  beta?: string[];
  comission_type: string;
  comission_value: number;
  recurring_comission_type: string;
  recurring_comission_value: number;
  comission_on_first_invoice: boolean;
  membership_comission_type: string;
  membership_comission_value: number;
  charge_type: string;
  currency_id: number;
  price: number;
  plan?: Plan[];
  recurring_value: number;
  recurring_frequency_type: string;
  recurring_frequency_type_select?: string;
  recurring_frequency: number;
  undetermined_charges: boolean;
  limit_charges: number;
  overdue_limit: number;
  permanent_access: boolean;
  membership_fee: boolean;
  membership_price: number;
  trial: boolean;
  trial_days: number;
  visible: boolean;
  auto_affiliation: boolean;
  infinity_funnel: boolean;
  recruit: boolean;
  recruit_commission_type: string;
  recruit_commission_value: number;
  recruit_max_sales: number;
  funnel_commission: number;
  affiliate_instructions: string;
  affiliation_contract: string;
  type: number;
  cnt_partner_cod: EPartnerCode;
  author_name: string;
  alternative_url: string;
  refund_days: number;
  prelaunch: boolean;
  launch_date: string;
  sales_expectation: number;
  program_content: string;
  support_email: string;
  categories: any[];
  url_thankyou_card: string;
  url_thankyou_boleto: string;
  friendly_name: string;
  recovery_email: string;
  has_children: boolean;
  thankyou_type: number;
  webhook_type: string;
  webhook: boolean;
  webhook_url: string;
  parent_product: number;
  parent_id: number;
  name_extract_description: string;
  unlimited_installment: boolean;
  deliver_first_charge: boolean;
  coproducers: Array<ICoProducer>;
  deliveries: Array<any>;
  physicalDelivery: any;
  stock: number;
  notify_stock: number;
  recurring_start_charging: string;
  recurring_days_start_charging: number;
  document_on_checkout: boolean;
  email_welcome: boolean;
  ask_address_checkout: boolean;
  ask_address_thanks: boolean;
  hide_quantity: boolean;
  url_checkout: string;
  is_producer: boolean;
  moderation_status: string;
  default_sales_page: string;
  yearly_installment: boolean;
  producer_id: number;
  remove_access: boolean;
  affiliation_status: string;
  can_create_pixel?: boolean;
  auto_refund: boolean;
  connects: number;
  allows_eduzz_balance: boolean;
  allow_affiliation: boolean;
  private_label_rights: number;
  allows_upgrade: boolean;
  allows_downgrade: boolean;
  marketplace: boolean;
  marketplace_variation: number;
  send_billing_reminder: boolean;
  plan_title?: string;
  plan_description?: string;
  prices?: SubscriptionPlanPrice[];
  hash?: string;
  allow_all_deliveries_for_free_charge_product?: boolean;
  getRecurringStartCharging(): string;
  getExpirationDate(): string;
  getIdCategories(): Array<number>;
  getLaunchDate(): string;
  setCategories(categories: any[]): void;
  getGeneralProperties(): any;
  getSalesProperties(): any;
  getAffiliatesProperties(): any;
  hasVariations(): boolean;
  isMainProduct(): boolean;
  isMainWithChildren(): boolean;
  isVariation(): boolean;
  setParent(id: number): void;
  serviceFormat(): any;

  getCoProducers(): Array<ICoProducer>;
  getCoProducersForSubmit(): Array<ICoProducer>;
  setCoProducers(coproducer: Array<ICoProducer>): void;
  addNewCoProducer(coproducer: ICoProducer): void;
  removeCoProducer(coproducer: ICoProducer): void;
  getNewCoProducers(): Array<ICoProducer>;

  getDeliveries(): Array<any>;
  setDeliveries(deliveries: Array<any>): void;
  addNewDelivery(coproducer: any): void;
  removeDelivery(coproducer: any): void;
  getPhysicalDelivery(): any;
  setPhysicalDelivery(physicalDelivery: any): void;
  getProductStatus(): number;
}

export default IProduct;
